import React, { useEffect, useState } from 'react';
import LocationsBranches from './LocationsBranches'
import LocationsMap from './LocationsMap'
const LocationsDashboard = (
  props
) => {

  const [selectedBranch, setSelectedBranch] = useState(null);

  return (
    <div className="row locations-page-wrapper" style={{display: "flex", marginBottom: "24px"}}>
      <div className="col-xs-12 col-md-4">
         <LocationsBranches {...props} setSelectedBranch={setSelectedBranch}/>
      </div>
      <div className="col-xs-12 col-md-8 place-body" style={{marginBottom: "24px"}}>
        <LocationsMap {...props} selectedBranch={selectedBranch}/>
      </div>
    </div>
  )
};

export default LocationsDashboard